<template>
    <VueMultiselect
        selectLabel=""
        v-model="associate"
        track-by="code"
        label="name"
        :loading="loading"
        placeholder="Type Associate Code, CEA License or Name"
        @search-change="onSearch"
        :options="associates">
    </VueMultiselect>
</template>

<script>
import VueMultiselect from 'vue-multiselect';
import { ref, inject, getCurrentInstance } from 'vue';
import { useRouter } from "vue-router";
import { store } from '../store.js';
import axios from 'axios';

export default {
    components: {
        VueMultiselect
    },
    setup() {
        const app = getCurrentInstance();
        const router = useRouter();
        const swal = inject('$swal');
        const associate = ref([]);
        const associates = ref([]);
        const loading = ref(false);

        return {
            app, store, swal, router,loading,
            associate, associates
        }
    },
    watch: {
        associate() {
            if (this.associate) {
                this.showDetails = true;
                store.associate = this.associate;
            } else {
                this.showDetails = false;
            }
        }
    },
    methods: {
        onSearch(q) {
            if(q.length >= 4) {
                this.goSearch(q);
            }
        },
        async goSearch(q) {
            let model = this;
            this.loading = true;
            await axios
            .get(process.env.VUE_APP_ENDPOINT+'/agent/search',{
                params: {
                    q: q
                }
            })
            .then(function (res) {
                model.loading = false;
               let x = 0;
                let option = [];
                for (let row of res.data.associates.data) {
                    if (row.cea_regno) {
                        option[x] = {
                            code: row.asc_code,
                            name: row.asc_code + ' - ' + row.name + ' ('+ row.cea_regno +')'
                        };
                    } else {
                        option[x] = {
                            code: row.asc_code,
                            name: row.asc_code + ' - ' + row.name
                        };
                    }
                    x++;
                }
                model.associates = option;
            })
            .catch(function (error) {
                model.loading = false;
                if (error.response && error.response.status == 401) {
                    model.router.push({ name: 'Logout' });
                } else if (error.response && error.response.status != 500) {
                    if (error.response.data.errors.slug) {
                        model.error.slug = error.response.data.errors.slug.slice(0,1).shift();
                    }
                } else {
                    model.swal({
                        icon: 'error',
                        text: model.app.appContext.config.globalProperties.$error500,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                }
            });
        }
    }
	
}
</script>
<style src="@/assets/vue-multiselect.min.css"></style>
<style>
    .multiselect__option--group {
        font-weight: bold;
    }

    .multiselect__option--highlight {
        background:#FCEBEC;
        color:#D63F3E;
    }
</style>